import { ReactNode } from 'react';
import { Box as OmniBox, Divider } from '@cof/omni-react';
import { colorBackgroundDisabled } from '@cof/omni-tokens';

export const Box = ({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) => {
  return (
    <OmniBox
      style={{
        margin: '15px',
        padding: '5px 20px 20px',
        backgroundColor: colorBackgroundDisabled,
      }}
    >
      {title ? (
        <>
          <h3 style={{ fontSize: '1em' }}>{title}</h3>
          <Divider />
        </>
      ) : null}

      {children}
    </OmniBox>
  );
};
